import React from 'react'

import BlogPostPreview from '../BlogPostPreview'

export default class BlogArchive extends React.Component {
  render () {
    const { posts } = this.props
    return (
      <div className="blog-wrapper blog-archive-wrapper blog-more">
        { posts !== null
          && <div className="blog-archive relative">
            <div className="blog-archive__content-wrapper">
              { posts.map((post, i) => (
                <BlogPostPreview
                  key={i}
                  title={post.fields.title}
                  slug={post.fields.slug}
                  id={post.sys.id}
                  date={post.fields.date}
                  src={post.fields.featuredImage.fields.file.url}
                  town={post.location.town}
                  region={post.location.region}
                  loaderHidden={true}
                />
              ))}
            </div>
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/blog-page/BlogArchive.js